import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Button,
} from "reactstrap";
import {
  NavLink as DomNavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import "moment-timezone";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;
import Switch from "react-bootstrap-switch";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const DeviceUrlAnnouncement = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);
  const [alert, setAlert] = useState(null);

  let formError = false;

  const [errorMsg, setErrorMsg] = useState(null);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.url.announcement"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  // Object containing all the form values
  const [urlValues, setUrlValues] = useState({
    serverUsername: "",
    serverPassword: "",
    serverProtocol: "",
    serverIpAddress: "",
    serverSSHTunnel: true,
  });

  // Object containing all error messages for every inputs
  const [urlStates, setUrlStates] = useState({
    serverUsername: "",
    serverPassword: "",
    serverProtocol: "",
    serverIpAddress: "",
    serverSSHTunnel: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setUrlValues({
      ...urlValues,
      [name]: value,
    });
  };

  const handleSSHTunnelChange = (e) => {
    const { props, state } = e;

    setUrlValues({
      ...urlValues,
      ["serverSSHTunnel"]: state.value,
    });
  };

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    // Validate all the field before calling the API
    setUrlStates({
      ...urlStates,
      ["serverIpAddress"]: validateField("serverIpAddress"),
    });

    if (!formError) {
      setUrlStates({
        ...urlStates,
        ["serverIpAddress"]: isValidIPAddress(urlValues["serverIpAddress"]),
      });
    }

    if (!formError) {
      postData();
    }
  };

  const isValidIPAddress = (ip) => {
    let status = "";
    const ipPattern = new RegExp(
      "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
    );

    if (!ipPattern.test(ip)) {
      status = "Invalid IP format";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }

    return status;
  };

  const validateField = (field) => {
    let status = "";
    if (urlValues[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const resetForm = () => {
    setUrlValues({
      ...urlValues,
      ["serverUsername"]: "",
      ["serverPassword"]: "",
      ["serverProtocol"]: "",
      ["serverIpAddress"]: "",
      ["serverSSHTunnel"]: true,
    });

    setUrlStates({
      ...urlStates,
      ["serverUsername"]: "",
      ["serverPassword"]: "",
      ["serverProtocol"]: "",
      ["serverIpAddress"]: "",
      ["serverSSHTunnel"]: "",
    });
  };

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "/api/v1/device/url_announcement";
    let apiMethod = "PUT";

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        serverUsername: urlValues.serverUsername,
        serverPassword: urlValues.serverPassword,
        serverProtocol: urlValues.serverProtocol,
        serverIpAddress: urlValues.serverIpAddress,
        serverSSHTunnel: urlValues.serverSSHTunnel,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg();
          resetForm();
          toast.success("URL added successfully on the GAM", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        {alert}
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/devices/list",
                      }}
                    >
                      GAM
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Details</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">URL Announcement</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      <li>{errorMsg}</li>
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>GAM Username</label>
                      <FormGroup
                        className={
                          urlStates["serverUsername"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter GAM username"
                          type="serverUsername"
                          name="serverUsername"
                          onChange={handleInputChange}
                          value={urlValues.serverUsername}
                        />
                        <label className="error">
                          {urlStates["serverUsername"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>GAM Password</label>
                      <FormGroup
                        className={
                          urlStates["serverPassword"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter GAM password"
                          type="serverPassword"
                          name="serverPassword"
                          onChange={handleInputChange}
                          value={urlValues.serverPassword}
                        />
                        <label className="error">
                          {urlStates["serverPassword"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>GAM IP Address</label>
                      <FormGroup
                        className={
                          urlStates["serverIpAddress"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter GAM IP address"
                          type="serverIpAddress"
                          name="serverIpAddress"
                          onChange={handleInputChange}
                          value={urlValues.serverIpAddress}
                        />
                        <label className="error">
                          {urlStates["serverIpAddress"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>SSH Tunnel</label>
                      <FormGroup
                        className={
                          urlStates["serverSSHTunnel"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Switch
                          name="ssh_tunnel"
                          offColor="success"
                          offText={<i className="nc-icon nc-simple-remove" />}
                          onColor="success"
                          onText={<i className="nc-icon nc-check-2" />}
                          onChange={handleSSHTunnelChange}
                          value={urlValues["serverSSHTunnel"] ? true : false}
                        />
                        <label className="error">
                          {urlStates["serverSSHTunnel"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeviceUrlAnnouncement;
